import {
	closestOptional,
	closestRequired,
	qsOptional,
	qsRequired, removeTrapFocus,
	targetRequired,
	trapFocus,
} from '@/scripts/core/global'
import { ProductFormGeneric } from '@/scripts/product-form-context/ProductFormGeneric'

export class WaitlistPopup extends ProductFormGeneric {
	static htmlSelector = 'waitlist-popup'
	detailsContainer: HTMLDetailsElement
	summaryToggle: HTMLElement
	closeButton: HTMLButtonElement
	wrap: HTMLElement
	onBodyClickEvent?: (event: Event) => void

	constructor() {
		super()
		this.detailsContainer = qsRequired('details', this)
		this.summaryToggle = qsRequired('summary', this)

		this.closeButton = qsRequired('button', this)
		this.wrap = qsRequired('[data-wrap]', this)

		this.detailsContainer.addEventListener('keyup', (event) => event?.code?.toUpperCase() === 'ESCAPE' && this.close())
		this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this))
		this.closeButton.addEventListener('click', (_: MouseEvent) => this.close())
		qsRequired('button[type="button"]', this).addEventListener('click', this.close.bind(this))

		this.summaryToggle.setAttribute('role', 'button')
	}

	isOpen() {
		return this.detailsContainer.hasAttribute('open')
	}

	onSummaryClick(event: Event) {
		event.preventDefault()
		const target = targetRequired(event)
		const closest = closestOptional(target, 'details')
		closest?.hasAttribute('open') ? this.close() : this.open(event)
	}

	onBodyClick(event: Event) {
		const target = targetRequired(event)
		if (!this.contains(target) || target.classList.contains('details-modal__overlay')) this.close(false)
	}

	open(event: Event) {
		const target = targetRequired(event)
		const closest = closestRequired(target, 'details')
		this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)
		closest.setAttribute('open', 'true')
		this.syncStickyCtaState()
		if (this.onBodyClickEvent) {
			document.body.addEventListener('click', this.onBodyClickEvent)
		}

		try {
			trapFocus(qsOptional('[tabindex="-1"]', this.detailsContainer))
		} catch (e) {
			console.log('no tabindex')
		}
	}

	close(focusToggle = true) {
		removeTrapFocus(focusToggle ? this.summaryToggle : undefined)
		this.detailsContainer.removeAttribute('open')
		this.syncStickyCtaState()
		if (this.onBodyClickEvent) {
			document.body.removeEventListener('click', this.onBodyClickEvent)
		}
	}

	// the sticky cta is fixed to the bottom of the viewport and would slide up over an open
	// popup on scroll - flag the body so it stays parked while a non-sticky popup is open
	syncStickyCtaState() {
		const openPopup = qsOptional('waitlist-popup:not(.waitlist-popup--sticky) details[open]')
		document.body.classList.toggle('waitlist-popup-open', !!openPopup)
	}
}
